export default __webpack_public_path__ + "static/media/icon-doc-search-plans.f8642dba.svg";